/**
 * No chrome at all — the screen paints its own full-page background.
 * Only the login route uses this; everything else goes through DefaultLayout,
 * which adds the sidebar and gates on an admin session.
 */
const BlankLayout = ({ children }) => <div>{children}</div>;

export default BlankLayout;
